module.exports = __webpack_public_path__ + "media/svg-new/grumpy-186da5bc.svg";